import ReviewsSection from './ReviewsSection'

export default ReviewsSection
